// extracted by mini-css-extract-plugin
module.exports = {"cell":"SidebarCell_cell__10QK_"};